import React from "react";

export default function NotFound() {
  return <div>allah ghalleb ya haj :( ti bara rawah</div>;
}
